// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fQ2L","controls":"styles_controls__37Yn8","charLimit":"styles_charLimit__3Qckk","input":"styles_input__ETkSq","send":"styles_send__10kKf"};